/**
 * A ficha de uma subcategoria ainda não salva nos modais de Cadastros.
 *
 * Papel: reproduz a pílula que `renderNewCatSubsList` e `renderSubChips`
 * desenham (l. 5893–5896, 5945–5950): `3px 10px`, 12 px, fundo `--background`,
 * borda bege e o "✕" de 13 px em `--texto-fraco`.
 *
 * Como usar: o "✕" chama `onRemover`, e quem monta tira a ficha da lista. O
 * nome acessível do "✕" é "Remover" seguido do texto da ficha, para cada um ser
 * achado pelo nome.
 */

interface FichaProps {
  /** O nome da subcategoria. */
  texto: string;
  onRemover: () => void;
}

/**
 * Uma ficha.
 *
 * @param texto - O que a ficha mostra.
 * @param onRemover - Chamado pelo "✕".
 * @returns A pílula.
 */
export function Ficha({ texto, onRemover }: FichaProps) {
  return (
    <span className="inline-flex items-center gap-1 rounded-[20px] border border-emb-borda bg-background px-2.5 py-[3px] text-[12px]">
      {texto}
      <button
        type="button"
        aria-label={`Remover ${texto}`}
        onClick={onRemover}
        className="cursor-pointer border-0 bg-transparent p-0 pl-0.5 text-[13px] leading-none text-texto-fraco"
      >
        ✕
      </button>
    </span>
  );
}
